import { AlertCircle, Info, X } from 'lucide-react'
import { openExternalUrl } from '../utils/openExternalUrl'
import './Modal.css'

function UpdateModal({ required, storeUrl, onDismiss }) {
  const handleUpdate = () => {
    if (storeUrl) openExternalUrl(storeUrl)
  }

  return (
    <div className="modal-overlay" style={{ zIndex: 9999 }}>
      <div className="modal-content confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{required ? 'Update Required' : 'Update Available'}</h2>
          {!required && (
            <button className="close-btn" onClick={onDismiss}>
              <X size={24} />
            </button>
          )}
        </div>

        <div className="confirm-content">
          <div className={required ? 'warning-icon danger' : 'warning-icon'}>
            {required ? <AlertCircle size={48} /> : <Info size={48} />}
          </div>
          <p>
            {required
              ? 'A critical update is required to continue using Press2DN. Please update to the latest version.'
              : 'A new version of Press2DN is available with improvements and bug fixes.'}
          </p>
        </div>

        <div className="modal-actions">
          {!required && (
            <button type="button" className="btn-secondary" onClick={onDismiss}>
              Later
            </button>
          )}
          <button type="button" className="btn-primary" onClick={handleUpdate}>
            Update Now
          </button>
        </div>
      </div>
    </div>
  )
}

export default UpdateModal
